import {
  Button,
  InputLabel,
  OutlinedInput,
  TextField,
  InputAdornment,
  IconButton,
  FormControl,
  Grid, FormHelperText
} from "@mui/material";
import {Visibility, VisibilityOff} from "@mui/icons-material";
import {useEffect, useState} from "react";
import {API} from "../framework/api";
import { confirmAlert } from 'react-confirm-alert';
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

export function PasswordResetConfirmPage(props) {

  const [passwordError, setPasswordError] = useState(false);
  const [values, setValues] = useState({
    username: '',
    hash: '',
    password: '',
    showPassword: false,
  });

  useEffect(() => {
    const s = document.location.hash.split('/');
    setValues({ ...values,
      hash: s[s.length - 1],
      username: s[s.length - 2]
    });
  }, []);

  const handleChange = (event, prop) => {
    setValues({ ...values, [prop]: event.target.value });

    switch (prop) {
      case 'password':
        setPasswordError(event.target.value.length < 6);
        break;
      default: // No action
    }

  };

  const handleClickShowPassword = () => {
    setValues({
      ...values,
      showPassword: !values.showPassword,
    });
  };

  const handlePwReset = () => {
    API.getAPI().user_reset_password_confirm(values.username, values.hash, values.password).then(()=> {
      confirmAlert({
        title: "Återställning genomförd",
        message: "Ditt lösenord har uppdaterats. Du kan nu logga in med ditt nya lösenord.",
        buttons: [{
          label: "Ok",
          onClick: () => { document.location.hash="#/login"; }
        }]
      });
    }).catch((e) => {
      confirmAlert({
        title: "Begäran misslyckades",
        message: "Begäran om lösenordsåterställning misslyckades. Kontrollera dina uppgifter och försök igen.",
        buttons: [{
          label: "Avfärda",
          onClick: () => {}
        }]
      });
      console.error(e);
    });
  }

  return (
    <div>
      <div className={"App-title"}>Lösenordsåterställning - Steg 2</div>
      <div className={"App-container App-drop-shadow"}>
        <Grid container={true} spacing={2}>
          <Grid item xs={12} sm={12}>
            <div className={"App-fieldTitle"}>Användarnamn</div>
          </Grid>
          <Grid item xs={12} sm={12}>

            <TextField
              disabled
              fullWidth={1}
              type="text"
              id="username"
              label="Användarnamn"
              variant="outlined"
              value={values.username}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <div className={"App-fieldTitle"}>Återställningsnyckel</div>
          </Grid>
          <Grid item xs={12} sm={12}>

            <TextField
              disabled
              fullWidth={1}
              type="text"
              id="hash"
              label="Återställningsnyckel"
              variant="outlined"
              value={values.hash}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <div className={"App-fieldTitle"}>Nytt lösenord</div>
          </Grid>
          <Grid item xs={12} sm={12}>

            {/*** Lösenord ***/}

            <FormControl variant="outlined" fullWidth={1}>
              <InputLabel htmlFor="outlined-adornment-password">Lösenord</InputLabel>
              <OutlinedInput
                fullWidth={1}
                id="outlined-adornment-password"
                type={values.showPassword ? 'text' : 'password'}
                value={values.password}
                error={passwordError}
                onChange={(e) => handleChange(e, 'password')}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      edge="end"
                    >
                      {values.showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                }
                label="Password"
              />
              {passwordError ?<FormHelperText id="outlined-adornment-password-helper-text" className={"Mui-error"}>Måste bestå av minst 6 tecken</FormHelperText>: null}
            </FormControl>


          </Grid>
          <Grid item xs={12} sm={12} className={"u-textRight u-marginT20"}>

            <Button
              className={"App-button-contained"}
              variant={"contained"}
              onClick={handlePwReset}
            >
              Återställ mitt lösenord
            </Button>
          </Grid>
        </Grid>

      </div>
      <div className={"App-footer"}>
        {/*** Hjälptext och länk till registrering ***/}

        Har du inget konto? Klicka <span className={"u-clickable u-bold"} onClick={() => { document.location.hash = "#/register"; }}>här för att registrera dig</span>.
      </div>
    </div>
  );
}
